import React, { useState } from 'react';
import { Button } from 'components/Button';
import { TextInput, TextInputProps } from 'components/Forms';
import { useTranslation } from 'react-i18next';

export type Props = TextInputProps;

export const PasswordInput = React.forwardRef<HTMLInputElement, Props>(function PasswordInputWithRef(
  props: Props,
  ref?: React.ForwardedRef<HTMLInputElement>,
): JSX.Element {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <TextInput
      {...props}
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      endAdornment={
        <Button
          variant="ghost"
          size="sm"
          className="relative px-8 my-6 mr-6 sm:my-8 sm:mr-8 ml-[-8px] min-h-0"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? t('login.form.fields.hidePassword') : t('login.form.fields.showPassword')}
        </Button>
      }
    />
  );
});
